/**
 * A list of all UI errors.
 */

/**
 * Indicates that a Feedback request is currently in progress.
 *
 * @type {{FEEDBACK_REQUEST_IN_PROGRESS: string}}
 */
export const FEEDBACK_REQUEST_IN_PROGRESS = 'FeedbackRequestInProgress';


/**
 * Indicated an attempted audio only screen share session with no audio track present
 *
 * @type {{AUDIO_ONLY_SCREEN_SHARE_NO_TRACK: string}}
 */
export const AUDIO_ONLY_SCREEN_SHARE_NO_TRACK = 'AudioOnlyScreenShareNoTrack';
